<template>
  <div class="index">

  </div>

</template>
<script>
  import {getAdminInfoByValidateurl, OK,HOST,casHost} from '../api/data.js'
  import moment from 'moment'
  export default {
    name: 'AdminCasLogin',
    data() {
      return {
        ticket:""
      }
    },
    filters: {
      formatDate: function (value) {
        return moment(value).format('YYYY-MM-DD HH:mm')
      },
      hideMiddle(val) {
        return `${val.substring(0,1)}**`
      }
    },

    created: function () {
      let ticket = decodeURIComponent((new RegExp('[?|&]' +  'ticket' + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null;
      let isMobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      //console.log('ticket1:'+ticket)
      const host = window.location.hostname
      const protocol = window.location.protocol
      const port =    window.location.port

      let service = protocol + "//" + host;
      if ("80"!==port|| "443"!==port) {//默认端口，不加在跳转路径下
        service += ":" + port+"/#/adminCasLogin";
      }else {
        service +="/#/adminCasLogin";
      }
      localStorage.setItem("userType", 'admin');
      const isAdminType = this.$store.state.isAdminType;
      const roleType = this.$store.state.roleType;

      if(ticket==null){
        let redirect = casHost + "login?service=" + service;
        window.location.href = redirect
      }else {
        let validateurl = casHost + "p3/serviceValidate?" + "ticket=" + ticket + "&" + "service=" + service;
        getAdminInfoByValidateurl(validateurl).then(res=>{
           // console.log("getAdminInfoByValidateurl")
           // console.log(res)\
            if(res.data.state === OK) {
              this.$store.dispatch('setRoleType',"3");//记录登录的角色
              //我们设置一个名为Flag，值为isLogin的字段，作用是如果Flag有值且为isLogin的时候，证明用户已经登录了。
              localStorage.setItem("Flag", "isLogin");
              localStorage.setItem("operator", res.data.data.operator);//登录账号
              localStorage.setItem("adminId", res.data.data.adminId);
              localStorage.setItem("usertype", res.data.data.type);
              localStorage.setItem("adminName", res.data.data.adminName); //姓名
              localStorage.setItem("telPhone", res.data.data.telePhone); //手机号码
              if(isMobile!=null) {//手机版页面
                this.$router.push({
                  path: '/adminIndex'
                })

              }
            }else {
              window.location.href = casHost
            }

          }).catch(error=>{
            console.log("错误"+error);
          })
        }


    },

    //页面加载
    mounted() {


    },
    methods: {
      // 判断移动端还是pc端
      _isMobile(){
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        return flag;
      },


    },

    components:{

    }
  }
</script>

<style lang="scss" scoped>
  @import "../assets/baseScss.scss";
  .index{
    margin-top:25px;
    margin-bottom:50px;
    .mint-navbar{
      a{
        .mint-tab-item-label{
        }
      }

      .mint-tab-item{
        padding:10px 0;
        font-size: 13px;
      }
      .mint-tab-item-label{
        font-size: 13px;
        border-right: solid 1px $cl9;
      }
    }
    .mint-tab-item.is-selected{
      border:none;
    }
    .is-selected{
      margin-bottom: 0px !important;
    }
  }
  .content{
    font-size:0.8rem;
    color:gray;
    .content-item{
      border-bottom:1px solid lightgray;
      padding:0.8rem 0.5rem;
      .top{
        display:flex;
        .headPortrait{
          margin-right: 0.3rem;
          img{
            width: 2rem;
            height:2rem;
          }
        }
        .baseInfo{
          padding:1px 0;
          .nameAndTime{
            text-align:left;
            overflow: hidden;
            .name{
              margin-right:2rem;
            }
            .time{

            }
          }
          .typeAndTitle{
            overflow:hidden;
            .type{
              padding:0.1rem 0.5rem;
              color:white;
              background:#4caf50;
              border-radius: 10%;
              margin-right:1rem;
              font-weight:lighter;
            }
            .infoTitle{
              width:100%;
              height:50px;
              line-height:25px;
              overflow:hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
            }
            .title{
              color:black;
            }
          }
        }
      }
      .center{
        padding:0.5rem;
        text-align:left;
        margin-top: 20px;
        word-break:break-all;
        .imgShow{
          display:flex;

          align-items: center;
          justify-content: space-around;


        }
      }
      div{ word-wrap: break-word; word-break: normal;}
      .titleInfo{
        width:100%;
        height:25px;
        line-height:25px;
        overflow:hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
      .infoContent{
        width:100%;
        height:20px;
        line-height:20px;
        overflow:hidden;
        text-overflow: ellipsis;
        /* display: -webkit-box;*/
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .imgShow-item{

             width:3.5rem;
             height:3.5rem;
             padding:0.2rem;
             margin-left: 5px;
             display: inline-block;
             img{
               width:100%;
               height:100%;
             }
           }

      .bottom1{
        overflow:hidden;
        .classify{
          float:left;
        }
        .option{
          float:right;
          overflow:hidden;
          .browse{
            float:left;
          }
          .infobrowse{
            float:left;
            padding-top: 6px;
            margin-right: 12px;
          }

        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/adminCasLogin.vue